import axiosInstance from "./AxiosInstance";

export function getContactTypeList(data) {
  return axiosInstance.post(`/contact-type/list`, data);
}

export function createContactTYpe(data) {
  return axiosInstance.post(`/contact-type/create`, data);
}

export function updateContactTYpe(data) {
  return axiosInstance.post(`/contact-type/update`, data);
}
export function deleteContactTYpe(data) {
  return axiosInstance.post(`/contact-type/delete`, data);
}

export function getSerachContactTypeList(data) {
  return axiosInstance.post(`/contact-type-search-list`, data);
}
